import {Button, Form, Input, InputNumber, message, Modal, ModalProps, Space, Table} from "antd";
import {useForm, useWatch} from "antd/lib/form/Form";
import {ColumnProps} from "antd/lib/table";
import {useEffect, useState} from "react";
import ProductSelectModal from "../../../components/ProductSelectModal";
import styles from "./ModifyGiveawayModal.module.css";


interface ModifyGiveawayModalProps extends ModalProps {
    giveaways: Array<any>
    onFinish: Function
}

function ModifyGiveawayModal(props: ModifyGiveawayModalProps) {
    const {giveaways = [], ...otherProps} = props;
    const [form] = useForm();
    const [productSelectModalVisible, setProductSelectModalVisible] = useState(false);

    const products = useWatch('giveaways', form);

    const onOk = (e: any) => {
        form.validateFields().then(value => {
            props.onFinish(value);
        })
    }

    useEffect(() => {
        form.setFieldValue('giveaways', giveaways);
    }, [giveaways]);


    const handleProductSelected = (keys?: Array<number>, records?: Array<any>) => {
        const exist = records?.find((p: any) => !!products.find((pp: any) => pp.productId == p.id))
        if (!!exist) {
            message.error('所选赠品已存在');
        } else {
            const newProducts = [...records || []].map((p: any) => ({
                ...p,
                productId: p.id,
                id: undefined,
                qty: 1,
                productCode: p.code,
                productName: p.name,
            }));
            form.setFieldValue('giveaways', [...products, ...newProducts]);
        }
        setProductSelectModalVisible(false);
    }

    const handleAdd = () => {
        setProductSelectModalVisible(true);
    }

    const handleRemove = (index: number) => {
        const newProducts = [...products || []].filter((p: any, i) => i != index)
        form.setFieldValue('giveaways', newProducts);
    }

    const columns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'operation',
            title: '操作',
            render(v: any, _: any, i) {
                return (
                    <Space>
                        <Button onClick={() => handleRemove(i)}>-</Button>
                        <Button onClick={handleAdd}>+</Button>
                    </Space>
                )
            }
        },
        {
            dataIndex: 'productCode',
            title: '商品编码'
        },
        {
            dataIndex: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'specification',
            title: '商品规格'
        },
        {
            dataIndex: 'unit',
            title: '单位'
        },
        {
            dataIndex: 'qty',
            title: <p style={{color: 'var(--danger-color)'}}>赠品数量</p>,
            render(v: any, r: any, i) {
                return <Form.Item name={[i, 'qty']}>
                    <InputNumber step={1}/>
                </Form.Item>
            }
        }
    ];

    return <Modal {...otherProps} title={'修改赠品'} width={800} onOk={onOk}>
        <Form form={form}>
            <Form.List name={'giveaways'}>
                {(fields, operation, meta) => (
                    <Table className={styles.ProductTable} columns={columns} pagination={false}
                           dataSource={form.getFieldValue('giveaways')?.length ? form.getFieldValue('giveaways') : [{}]}/>
                )}
            </Form.List>
            <Form.Item name={'remark'} label={'备注'}>
                <Input.TextArea rows={3}/>
            </Form.Item>
        </Form>
        <ProductSelectModal multiple open={productSelectModalVisible} onComplete={handleProductSelected}
                            onCancel={() => setProductSelectModalVisible(false)}/>
    </Modal>
}

export default ModifyGiveawayModal;